import { validPropMultiSelectVM } from '../../../../core/components/validation/ValidInputMultiSelect';
import { validPropTextVM } from '../../../../core/components/validation/ValidInputText';
import utilSvc from '../../../../core/utilSvc';
import { AdminMFRRestrictionModel } from './mfr_edit_restrictions_types';
import { mfrFacilityTypeOptions } from './mfr_restrictions_edit_dropdown_options';

const mfrExemptionOptions = [...utilSvc.loc.stateNames()];

export function modelVM(data?): AdminMFRRestrictionModel {
    /**
     * We are doing some weird mishmashing of data here, because the API
     * returns the `CeRestrictTypes` as an array with the string "ALL"
     * instead of an array of all the facility types.
     *
     * But in the UI we want to show all the selected facility types.
     *
     * Same goes with `ExemptStates` and the "NONE" value.
     */
    let facilityTypesData: any[] = [];
    let exemptStatesData: any[] = [];
    if (Array.isArray(data?.CeRestrictTypes)) {
        if (data.CeRestrictTypes[0] === 'ALL') {
            facilityTypesData.push('ALL');
        }
        if (data.CeRestrictTypes[0] !== 'ALL') {
            facilityTypesData = data?.CeRestrictTypes ?? [];
        }
    }
    if (Array.isArray(data?.ExemptStates) && data.ExemptStates[0] !== 'NONE') {
        exemptStatesData = data?.ExemptStates ?? [];
    }

    return {
        Id: data?.Id ?? '',
        ParentCo: validPropTextVM('ParentCo', 'Parent Company', data?.ParentCo ?? '', ''),
        CeRestrictTypes: validPropMultiSelectVM(
            'CeRestrictTypes',
            'Facility Types',
            facilityTypesData,
            'Facility Types',
            mfrFacilityTypeOptions,
        ),
        ExemptStates: validPropMultiSelectVM(
            'ExemptStates',
            'Exempted States',
            exemptStatesData,
            'Exempted States',
            mfrExemptionOptions,
        ),
    };
}
